import React from 'react'
import ReactDOM from 'react-dom'

import 'assets/scss/material-dashboard-pro-react.css?v=1.4.0'
import "react-vis/dist/style.css"
import App from './App'

ReactDOM.render(
  <App/>,
  document.getElementById('root')
);